export default __webpack_public_path__ + "static/media/5.48bbc624.PNG";